// /composables/useAutosaveCriticalGoals.js
import { computed, watch, onBeforeUnmount } from 'vue'
import { useAnalysisStore } from '@/stores/Setup/analysis'
import { useCriticalGoalsStore } from '@/stores/WheelAnalysis/criticalGoals'

export default function useAutosaveCriticalGoals() {
    const analysis = useAnalysisStore()
    const critical = useCriticalGoalsStore()

    // Only save when we have an ID and we’re not hydrating
    const canSave = computed(() => !!analysis.wheelAnalysisId && !critical.isHydrating)

    let t = null
    const DEBOUNCE_MS = 250

    function scheduleSave() {
        if (!canSave.value) return
        clearTimeout(t)
        t = setTimeout(() => {
            try {
                critical.selectedCriticalGoalsChanged()
            } catch (e) {
                if (process.env.NODE_ENV !== 'production') {
                    // eslint-disable-next-line no-console
                    console.debug('Autosave selectedCriticalGoals failed:', e)
                }
            }
        }, DEBOUNCE_MS)
    }

    // Deep watch the 1D array (deep ensures we catch element toggles)
    watch(
        () => critical.selectedCriticalGoals,
        () => scheduleSave(),
        { deep: true }
    )

    // When we transition from not-ready -> ready, flush once if there were edits
    watch(canSave, (ok, wasOk) => {
        if (ok && !wasOk) scheduleSave()
    })

    onBeforeUnmount(() => clearTimeout(t))
}
